import { Select } from 'antd'
import { useConfiguredOptions } from '../hooks'
import { selectedOptionIds } from '../utils'
import type { ArraySelectProps } from '../types'

/** Preserves array values even when the field permits only one selection. */
function ArraySelect({
  accessibility,
  disabled,
  field,
  onBlur,
  onChange,
  value,
}: ArraySelectProps) {
  const optionIds = selectedOptionIds(field, value)
  const options = useConfiguredOptions(field, optionIds)

  return (
    <Select
      {...accessibility}
      allowClear={!disabled}
      disabled={disabled}
      mode={field.single ? undefined : 'multiple'}
      onBlur={onBlur}
      onChange={(selection: string | string[] | undefined) => {
        if (typeof selection === 'string') onChange([selection])
        else onChange(selection ?? [])
      }}
      options={options}
      style={{ width: '100%' }}
      value={field.single ? optionIds[0] : optionIds}
    />
  )
}

export default ArraySelect
